/* ASMA playful commerce motion: auto-crossfade visible touch cards */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touchLayout = window.matchMedia('(hover: none) and (pointer: coarse)').matches || window.innerWidth < 750;
  const visibleMedia = new Set();
  let observer;
  let timer;

  function prepare(root = document) {
    const mediaNodes = root.querySelectorAll('.media.media--hover-effect');
    mediaNodes.forEach((media) => {
      if (media.dataset.asmaMotionReady === 'true') return;
      const images = media.querySelectorAll('img');
      if (images.length < 2) return;

      media.dataset.asmaMotionReady = 'true';
      const card = media.closest('.card');
      if (card) card.classList.add('asma-motion-card');
      if (!touchLayout || reducedMotion) return;

      if (!observer) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) visibleMedia.add(entry.target);
            else {
              visibleMedia.delete(entry.target);
              entry.target.classList.remove('asma-motion-show-secondary');
            }
          });
        }, { threshold: 0.45 });
      }
      observer.observe(media);
    });

    if (touchLayout && !reducedMotion && !timer) {
      timer = window.setInterval(() => {
        if (document.hidden) return;
        visibleMedia.forEach((media) => {
          if (!media.matches(':hover')) media.classList.toggle('asma-motion-show-secondary');
        });
      }, 4200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare());
  else prepare();

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('shopify:section:reorder', () => prepare());
})();
